import { PipeTransform } from '@angular/core';
var MapPipe = /** @class */ (function () {
    function MapPipe() {
    }
    MapPipe.prototype.transform = function (value, fn) {
        return fn(value);
    };
    return MapPipe;
}());
export { MapPipe };
